import api from "../api/index"

let school = {
  state: {
    isLogin: false,
    isShowSearch: false,
    liveData: [],
    currentPage:'',
    schoolMode:[
      {
        bgImg:require('../assets/school/bgblue.png'),
        color:"#4777F7",
        bgColor:"rgba(71,119,247,0.2)",
        tagColor:"rgba(71,119,247,0.08)",
      },
      {
        bgImg:require('../assets/school/bgblue.png'),
        color:"#4777F7",
        bgColor:"rgba(71,119,247,0.2)",
        tagColor:"rgba(71,119,247,0.08)",
      },
      {
        bgImg:require('../assets/school/bggreen.png'),
        color:"#08D9AC",
        bgColor:"rgba(8,217,172,0.2)",
        tagColor:"rgba(8,217,172,0.08)",
      },
      {
        bgImg:require('../assets/school/bgred.png'),
        color:"#FF3B47",
        bgColor:"rgba(255,59,71,0.2)",
        tagColor:"rgba(255,59,71,0.08)",
      },
    ],
    modeType:0,
  },
  mutations: {
    loginStatusInit(state, val) {
      if (localStorage.getItem("user_token_" + localStorage.getItem("c_id"))) {
        api.livechecktoken(localStorage.getItem("user_token_" + localStorage.getItem("c_id"))).then((res) => {
            if (res.data.data.stats != "1") {
              localStorage.removeItem("user_token_" + localStorage.getItem("c_id"));
              state.isLogin = false;
            } else {
              state.isLogin = true;
            }
          });
      } else {
        state.isLogin = false;
      }
    },
    setSchoolSearch(state, val) {
      state.isShowSearch = val;
    },
    setLiveData(state, val) {
      state.liveData = val;
    },
    setCurrentPage(state, val){
      state.currentPage = val
    },
    setSchoolMode(state, val){
      state.modeType = val - 1
    }
  },
};

export default school;
